import React from 'react'
import { graphql } from 'relay-runtime'
import { useLazyLoadQuery } from 'react-relay'
import { MenuItem, TextField } from '@mui/material'
import { OwnerSelectQuery } from './__generated__/OwnerSelectQuery.graphql'

const ownerSelectQuery = graphql`
  query OwnerSelectQuery($input: AdminListUsersRequest!) {
    adminListUsers(input: $input) {
      data {
        id
        email
        fullName
      }
    }
  }
`

interface OwnerSelectProps {
  accountId: string
  value: string | null
  onChange: (ownerId: string | null) => void
}

/**
 * Dropdown to choose an account owner from the users belonging to that account.
 */
export const OwnerSelect = ({ accountId, value, onChange }: OwnerSelectProps) => {
  const data = useLazyLoadQuery<OwnerSelectQuery>(
    ownerSelectQuery,
    { input: { accountId, pageNumber: 0, pageSize: 200 } },
    { fetchPolicy: 'store-and-network' }
  )

  const users = data.adminListUsers.data ?? []

  return (
    <TextField
      select
      fullWidth
      margin="normal"
      label="Owner"
      value={value ?? ''}
      onChange={(event) =>
        onChange(event.target.value === '' ? null : event.target.value)
      }
      helperText="Optional — a user belonging to this account"
    >
      <MenuItem value="">
        <em>None</em>
      </MenuItem>
      {users.map((user) => (
        <MenuItem key={user.id} value={user.id}>
          {user.fullName || user.email || user.id}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default OwnerSelect
